export default __webpack_public_path__ + "static/media/C_Cavalo.96b951cf.svg";